module.exports = __webpack_public_path__ + "img/splash.87366ff5.jpeg";